import { HTMLRenderer } from '@bts-web/core-features/common';
import { FilledInfo } from '../../../../common/svgIcons';
import { css } from '@bts-web/utils-style-engine';

interface SavingsPlanInfoProps {
  className?: string;
  label: string;
}

const SavingsPlanInfo = ({ label, className }: SavingsPlanInfoProps) => (
  <li
    className={`${css({
      color: 'neutrals.text_secondary',
      display: 'flex',
      gap: 'extra_small_2',
    })} ${className ?? ''}`}
  >
    <FilledInfo size={18} />
    <p
      className={css({
        fontSize: 'body.medium',
        fontWeight: 'body.medium',
        lineHeight: 'body.medium',
        letterSpacing: 'body.medium',
      })}
    >
      <HTMLRenderer>{label}</HTMLRenderer>
    </p>
  </li>
);

export { SavingsPlanInfo };
